import { ProjectToolDetailPage } from "@/features/projects/project-tool-detail.page";
import { createFileRoute } from "@tanstack/react-router";

// CR-176: one catalog tool on its own page. Tool ids are only unique per
// surface, so the surface ("assistant" | "mcp") is part of the URL. An unknown
// surface or id simply matches no tool, and the page shows "Tool not found".
export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/tools/$surface/$toolId",
)({
  component: ProjectToolDetailRoute,
});

function ProjectToolDetailRoute() {
  const { surface, toolId } = Route.useParams();
  return <ProjectToolDetailPage surface={surface} toolId={toolId} />;
}
